import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { StyledGrid } from '@Utils/styles';
import { Button, Text } from '@innovyze/stylovyze';
import { Grid, Stack } from '@mui/material';

interface TableToolbarProps {
	isLoading: boolean;
	onRecalculateCount: () => void;
}

export const TableToolbar = ({
	isLoading,
	onRecalculateCount,
}: TableToolbarProps) => {
	const { t } = useGlobalization();

	return (
		<StyledGrid
			container
			style={{
				width: '100%',
				marginTop: '1rem',
				marginBottom: '1rem',
			}}>
			<Grid item xs={8}>
				<Text variant="heading-large-strong">{t('Score Setup')}</Text>
				<Text variant="caption-medium">
					{t(
						'Set your scores below to complete the component setup.',
					)}
				</Text>
				<Stack direction={'row'}>
					<Text variant="caption-medium">
						{t('To edit ranges, go back to the parameter setup.')}
					</Text>
					&nbsp;
					<Text variant="caption-medium-strong">
						{t('This will reset all scores.')}
					</Text>
				</Stack>
			</Grid>
			<Grid item xs={4} display="flex" justifyContent="flex-end">
				<Stack direction={'column'}>
					<Button
						disabled={isLoading}
						variant="outlined"
						onClick={() => {
							onRecalculateCount();
						}}>
						{t('Recalculate Asset Count')}
					</Button>
				</Stack>
			</Grid>
		</StyledGrid>
	);
};
